import { SlateApiReturn } from 'modules/editor';
import React from 'react';
import {
  bold,
  italic,
  list2,
  listNumbered,
  quotesLeft,
  strikethrough,
  underline,
} from 'react-icons-kit/icomoon';
import { getCommandKeyCopy } from 'shared/utils';
import { RichTextToolbarButton } from './RichTextToolbarButton';
import { RichTextToolbarLinkButton } from './fragments';

interface Props {
  editorApi: SlateApiReturn;
}

export const RichTextEditorToolbar: React.FC<Props> = ({ editorApi }) => {
  const commandKeyCopy = getCommandKeyCopy();
  const getShortcutCopy = (...keys: string[]) => keys.join('+');

  return (
    <ul className="slate__toolbar">
      <li>
        <RichTextToolbarButton
          variant="bold"
          icon={bold}
          label="Bold"
          shortcut={getShortcutCopy(commandKeyCopy, 'B')}
        />
      </li>
      <li>
        <RichTextToolbarButton
          variant="italic"
          icon={italic}
          label="Italic"
          shortcut={getShortcutCopy(commandKeyCopy, 'I')}
        />
      </li>
      <li>
        <RichTextToolbarButton
          variant="underline"
          icon={underline}
          label="Underline"
          shortcut={getShortcutCopy(commandKeyCopy, 'U')}
        />
      </li>
      <li>
        <RichTextToolbarButton
          variant="strikethrough"
          icon={strikethrough}
          label="Strikethrough"
          shortcut={getShortcutCopy(commandKeyCopy, 'Shift', 'X')}
        />
      </li>
      <li>
        <RichTextToolbarLinkButton
          editorApi={editorApi}
          label="Link"
          shortcut={getShortcutCopy(commandKeyCopy, 'Shift', 'L')}
        />
      </li>
      <li>
        <RichTextToolbarButton
          variant="blockquote"
          icon={quotesLeft}
          label="Quote"
          shortcut={getShortcutCopy(commandKeyCopy, 'Shift', '9')}
        />
      </li>
      <li>
        <RichTextToolbarButton
          variant="ul"
          icon={list2}
          label="Bulleted List"
          shortcut={getShortcutCopy(commandKeyCopy, 'Shift', '8')}
        />
      </li>
      <li>
        <RichTextToolbarButton
          variant="ol"
          icon={listNumbered}
          label="Numbered List"
          shortcut={getShortcutCopy(commandKeyCopy, 'Shift', '7')}
        />
      </li>
    </ul>
  );
};
